import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface IRejectApproveConfirmationDialogData {
  isApproval: boolean;
  isBulk: boolean;
}

@Component({
  selector: 'app-reject-confirmation',
  templateUrl: './reject-confirmation.component.html',
  styleUrls: ['./reject-confirmation.component.css']
})
export class RejectConfirmationComponent implements OnInit {
  inputText: string;
  constructor(
    private matDialogRef: MatDialogRef<RejectConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IRejectApproveConfirmationDialogData) { }

  ngOnInit(): void {

  }

  onAction(value: boolean) {
    this.matDialogRef.close({ value, comment: this.inputText });
  }

}
